import equipmentSelectors from '@/pages/Equipment/equipment.selectors'
import { useRecoilValue } from 'recoil'
import StatisticCard from './StatisticCard'
import { useMemo } from 'react'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom'
import css from './equipmentStatisticsWidget.module.css'
import cn from '@/utils/cn'

const EquipmentStatisticsWidget = () => {
  const equipmentList = useRecoilValue(equipmentAtom).items
  const equipmentCountByStatus = useRecoilValue(equipmentSelectors.selectEquipmentCountByStatus)
  const equipmentCountByFlag = useRecoilValue(equipmentSelectors.selectEquipmentCountByFlag)

  const equipmentInMaintenanceCount = useMemo(() => {
    return equipmentList.filter((item) => item.state !== 'DISCONNECTED' && item.statusFlag === 'IN_MAINTENANCE').length
  }, [equipmentList])

  return (
    <div className={css.wrapper}>
      <h2 className={cn('text-heading-4', css.title)}>Статистика</h2>
      <div className={css.cardsContainer}>
        <StatisticCard text={equipmentCountByStatus['RUNNING']} type={'NORMAL'} />
        <StatisticCard text={equipmentCountByFlag['WARNING']} type={'WARNING'} />
        <StatisticCard
          text={(equipmentCountByFlag['ERROR'] ?? 0) + (equipmentCountByFlag['FATAL_FAULT'] ?? 0)}
          type={'ERROR'}
        />
        <StatisticCard text={equipmentInMaintenanceCount} type={'IN_MAINTENANCE'} />
      </div>
    </div>
  )
}

export default EquipmentStatisticsWidget
